module.exports = __webpack_public_path__ + "assets/img/12.8084d06a.png";